/* Stienhardt - diamond PDP BE-style inline spec line (2026-06-25)
   Reads the populated stone specs and renders a single bullet line under the
   title: "<Cut> Cut  -  <Color> Color  -  <Clarity> Clarity  -  <Cert> Certified".
   Shape/Carat are intentionally omitted (already in the title). Pure additive +
   idempotent; never touches the form/data. Shown on mobile only (see CSS).
   Revert = remove the <script> in snippets/sp-diamond-pdp-hero-v2.liquid + this file. */
(function(){
  'use strict';
  var SEP='  ·  ';
  function txt(s){var e=document.querySelector(s);return e?(e.textContent||'').trim():'';}
  function build(){
    try{
      var title=document.querySelector('.product-single__title');
      if(!title) return;
      var cut=txt('.cut-info'),color=txt('.color-info'),clarity=txt('.clarity-info'),cert=txt('.certificate-type-info');
      var parts=[];
      if(cut) parts.push(cut+' Cut');
      if(color) parts.push(color+' Color');
      if(clarity) parts.push(clarity+' Clarity');
      if(cert) parts.push(cert+' Certified');
      if(!parts.length) return; // specs not populated yet
      var el=document.getElementById('sp-diamond-specline');
      if(!el){el=document.createElement('div');el.id='sp-diamond-specline';el.className='sp-diamond-specline';title.insertAdjacentElement('afterend',el);}
      el.textContent=parts.join(SEP);
    }catch(e){}
  }
  var n=0,iv=setInterval(function(){n++;build();if(n>=40)clearInterval(iv);},250);
  if(document.readyState!=='loading')build();else document.addEventListener('DOMContentLoaded',build);
})();
